import type { ReactNode } from "react";

import { ArtifactCardButton } from "./ArtifactCardButton";

export type ArtifactCardProps = {
	readonly name: string;
	readonly isLoading: boolean;
	readonly onClick: () => void;
	readonly isSelected?: boolean;
	readonly isDisabled?: boolean;
	readonly disabledTooltip?: string;
	readonly className?: string;
	readonly endComponent?: ReactNode;
	readonly bottomComponent?: ReactNode;
};

export default function ArtifactCard({
	name,
	isLoading,
	isSelected,
	isDisabled,
	disabledTooltip,
	className,
	endComponent,
	bottomComponent,
	onClick,
}: ArtifactCardProps) {
	if (!bottomComponent) {
		return (
			<div className="@container/artifact-card">
				<ArtifactCardButton
					name={name}
					isLoading={isLoading}
					isSelected={isSelected}
					isDisabled={isDisabled}
					disabledTooltip={disabledTooltip}
					className={className}
					endComponent={endComponent}
					onClick={onClick}
				/>
			</div>
		);
	}

	return (
		<div className="@container/artifact-card">
			<div className="grid w-fit max-w-full grid-cols-[minmax(0,1fr)]">
				<ArtifactCardButton
					name={name}
					isLoading={isLoading}
					isSelected={isSelected}
					isDisabled={isDisabled}
					disabledTooltip={disabledTooltip}
					className={className}
					endComponent={endComponent}
					onClick={onClick}
				/>
				<div className="flex min-w-0 justify-start">{bottomComponent}</div>
			</div>
		</div>
	);
}
